export const CHART_CONFIG = {
    height: 166,
    containerPadding: "12px 16px",
    borderRadius: "16px",
    border: "2px solid rgba(139, 69, 255, 0.3)",
    margins: { top: 0, right: 0, left: -45, bottom: 0 },
  } as const;
  
export const COLORS = {
    background: "linear-gradient(135deg, #2D1B4E 0%, #1A0B2E 100%)",
    text: "#FFFFFF",
    axisLabel: "#9CA3AF",
    gridLine: "rgba(255, 255, 255, 0.15)",
    axisLine: "rgba(255, 255, 255, 0.3)",
  } as const;
  
export const LEGEND_LABELS = {
    world: "В мире",
    russia: "В России",
  } as const;
  
export const AXIS_LABELS = {
    x: "Год",
    y: "Количество",
  } as const;